const setQuotationMarkTop = () =>{
    if(document.querySelector('.kruse-testimonial-card-content-quote-mark')){
        const allMarks = document.querySelectorAll('.kruse-testimonial-card-content-quote-mark');
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        if(vw < 1025 && allMarks.length > 0){

            let tH = 0.1;
            const observer = new IntersectionObserver(onIntersection, {
                root: null,
                threshold: tH
            })
            function onIntersection (entries, opts){
                entries.forEach(entry => {

                    if (entry.isIntersecting) {
                        let parent = entry.target.closest('.kruse-testimonial-card');
                        let imgWrapper = parent.querySelector('.kruse-testimonial-card-img-wrapper');
                        let imgWrapperHeight = imgWrapper.offsetHeight;
                        entry.target.style.top = imgWrapperHeight + 'px';
                        observer.unobserve(entry.target);

                    } else {


                    }
                });
            }
            allMarks.forEach(mark => {
                observer.observe(mark);
            })
        }else if(allMarks.length > 0){
            allMarks.forEach(mark =>{

                mark.style.top = '';
            })
        }

    }
}
export default setQuotationMarkTop;